import { isFeature } from 'Cloud/Application/FeaturesEs6';

/**
 * @see https://jira.vk.team/browse/CLOUDWEB-19100 Использовать путь файла из vars.request.home на странице r-seven/edit/home
 */
export const USE_PATH_FROM_HOME_PARAM = isFeature('use-path-from-home-param');
